import { DatumTypEnum } from '../models/DatumTypEnum';

export interface DateCategoryProps {
  id: number;
  value: DatumTypEnum;
  bezeichnung: string;
}

export const dateCategories: DateCategoryProps[] = [
  {
    id: 0,
    value: DatumTypEnum.ERFASSUNGSDATUM,
    bezeichnung: 'Erfassungsdatum',
  },
  {
    id: 1,
    value: DatumTypEnum.VERSANDDATUM,
    bezeichnung: 'Versanddatum',
  },
  {
    id: 2,
    value: DatumTypEnum.ZUSTELLDATUM,
    bezeichnung: 'Zustelldatum',
  },
];
